import { TranslateService } from '@ngx-translate/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { map } from 'rxjs/operators';

// Below code copied from https://github.com/juristr/egghead-ngx-formly-course/blob/16-extensions-ngx-translate/src/app/translate.extension.ts
export class TranslateExtension {
  constructor(private translate: TranslateService) {}
  prePopulate(field: FormlyFieldConfig) {
    const to = field.props || {};
    if (Array.isArray(to.options) && to.options.length) {
      const options = to.options;
      to.options = this.translate.stream(options.map(o => o.label)).pipe(
        map(labels => options.map(o => ({...o, label: labels[o.label]})))
      );
    }
    field.expressions = {
      ...(field.expressions || {}),
      ...(to.label
        ? {'props.label': this.translate.stream(to.label)}
        : {}),
      ...(to.description
        ? {'props.description': this.translate.stream(to.description)}
        : {}),
      ...(to.placeholder
        ? {'props.placeholder': this.translate.stream(to.placeholder)}
        : {}),
        ...(to.selectAllOption
          ? {'props.selectAllOption': this.translate.stream(to.selectAllOption)}
          : {}),
    };
  }
}

export function registerTranslateExtension(translate: TranslateService) {
  return {
    extensions: [
      {
        name: 'translate-extension',
        extension: new TranslateExtension(translate)
      }
    ]
  };
}